"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var Treemap = /** @class */ (function (_super) {
    tslib_1.__extends(Treemap, _super);
    function Treemap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Treemap.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'treemap';
        _super.prototype.createLayers.call(this, layerProps);
    };
    Treemap.getDefaultOptions = layer_1.default.getDefaultOptions;
    return Treemap;
}(plot_1.default));
exports.default = Treemap;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/treemap/index.js
// module id = 987
// module chunks = 37